import { render } from "./NoticeView.vue?vue&type=template&id=f81eb47e&scoped=true"
import script from "./NoticeView.vue?vue&type=script&lang=js"
export * from "./NoticeView.vue?vue&type=script&lang=js"

import "./NoticeView.vue?vue&type=style&index=0&id=f81eb47e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f81eb47e"]])

export default __exports__